import { Box } from "@chakra-ui/react";
import { METRIPORT_PURPLE } from "../../../shared-logic/style";

export function HccBadge() {
  return (
    <Box
      as="span"
      px="2"
      py="0.5"
      height="1.25rem"
      display="inline-flex"
      alignItems="center"
      borderRadius="full"
      fontSize="2xs"
      textTransform="uppercase"
      letterSpacing="0.05em"
      fontWeight="600"
      color="white"
      bg={METRIPORT_PURPLE}
      transition="all 0.2s ease"
    >
      HCC
    </Box>
  );
}
